import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyMultiple16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTypographyMultiple16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 3h9v1.988a.5.5 0 0 1-1 0V4H6v8h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H5V4H2v.988a.5.5 0 0 1-1 0zm11 5h-2V7h5v1h-2v5h-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyMultiple16);
